import type { FC, PropsWithChildren } from 'react';

import { AlignAndConstrain, StackContainer } from '@eneco/custom-components/accessmanagement';
import useDC from '@eneco/dc/useDC';
import { Box, Card, PageGrid, Stretch } from '@eneco/sparky';
import { useMediaQuery } from '@eneco/sparky/hooks';

export const Layout: FC<PropsWithChildren> = ({ children }) => {
  const isDesktop = useMediaQuery('md');
  const { label } = useDC();

  return (
    <Stretch>
      <StackContainer label={label}>
        <PageGrid>
          <PageGrid.Item gridColumn="1/-1">
            <Box paddingY="8">
              <AlignAndConstrain>
                {isDesktop ? (
                  <Card>
                    <Card.Content>{children}</Card.Content>
                  </Card>
                ) : (
                  <div>{children}</div>
                )}
              </AlignAndConstrain>
            </Box>
          </PageGrid.Item>
        </PageGrid>
      </StackContainer>
    </Stretch>
  );
};
